import { observer } from 'mobx-react';
import { useNavigate } from 'react-router';
import { useAgentSearch } from '../AgentSearchContext';
import { createSafeMarkup } from '../utils/sanitizeSearchHTML';
import { routes } from '../../../../utils/constants/routes';

const AgentSearchResultItem = observer(({ result }) => {
  const searchState = useAgentSearch();
  const navigate = useNavigate();

  const handleResultClick = () => {
    // Close modal first (gives immediate feedback)
    searchState.closeModal();

    // Navigate to the selected chat session
    const chatPath = routes.AGENT_CHAT_PATH.replace(':chatId', result.id);
    navigate(chatPath);
  };

  const formatRelativeTime = (timestamp) => {
    const now = new Date();
    const diffMs = now - timestamp;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffHours < 1) {
      const diffMins = Math.floor(diffMs / (1000 * 60));
      return diffMins < 1 ? 'Just now' : `${diffMins}m ago`;
    }
    if (diffHours < 24) {
      return `${diffHours}h ago`;
    }
    if (diffDays === 1) {
      return 'Yesterday';
    }
    if (diffDays < 7) {
      return `${diffDays}d ago`;
    }

    // For older dates, show formatted date
    return timestamp.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: timestamp.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  const getResultIcon = () => {
    return result.type === 'chat' ? '💬' : '📁';
  };

  return (
    <div
      className="agent-search-result-item"
      onClick={handleResultClick}
    >
      <div className="agent-search-result-content">
        <div className="agent-search-result-header">
          <div className="agent-search-result-icon">
            {getResultIcon()}
          </div>
          <div
            className="agent-search-result-title"
            dangerouslySetInnerHTML={createSafeMarkup(result.title)}
          />
          <div className="agent-search-result-time">
            {formatRelativeTime(result.timestamp)}
          </div>
        </div>
        <div
          className="agent-search-result-excerpt"
          dangerouslySetInnerHTML={createSafeMarkup(result.excerpt)}
        />
      </div>
    </div>
  );
});

export default AgentSearchResultItem;